export default "__VITE_ASSET__033af2ba__"